import { useEffect, useState } from "react";
import { NXCheck, NXCross, NXDelete, NXPlus } from "../../../icons";
import NxtbnDrawer from "../../drawer";
import { useDeleteConfirmation } from "../../common";
import useApi from "../../../api";
import { toast } from "react-toastify";
import TaxRateForm from "./TaxRateForm";

interface TaxClassViewPops {
  id: any;
  isOpen: any;
  onClose: ()=>void;
}

function TaxClassView({
  id,
  isOpen,
  onClose,
}: TaxClassViewPops) {

  const [taxClass, setTaxClass] = useState<any>();
  const [formData, setFormData] = useState<any>({ tax_class: id})
  const [isOpenTaxRateInput, setIsOpenTaxRateInput] = useState<boolean>(false)
  const [edit, setEdit] = useState<any>(null)
  const [errorData, setErrorData] = useState<any>()

  const api = useApi();


  const { handleDelete } = useDeleteConfirmation();

  const getDetailTaxClass = () => {
    api.getTaxClassById(id).then((response: any) => setTaxClass(response)).catch((error: any) => toast.error("Error Fetch tax class !!"));
  };

  useEffect(() => {
      getDetailTaxClass();
  }, [id]);

  const addTaxRate = (e:any) => {
    e.preventDefault()
    setFormData({tax_class: id})
    setIsOpenTaxRateInput(true)
  }



  const handleEdit = (item:any) => {
    setEdit(item)
    setFormData({tax_class: id, ...item})
  }

  return (
    <NxtbnDrawer
      isOpen={isOpen}
      onClose={onClose}
      title="Tax Class"
    >
      <div className="m-4">
        <div>
          <div className="mt-4 flex items-center gap-3">
            <h3>Name:</h3>
            <span>{taxClass?.name}</span>
          </div>
        </div>
        <div className="mt-4">
          <div className="flex justify-between items-center">
            <h3>Tax Rate</h3>
            <button
              onClick={addTaxRate}
              className="my-2 flex items-center gap-2 bg-primary-400 py-2 px-5 text-white rounded-md hover:bg-primary-500 transition-all duration-150 ease-linear"
            >
              <NXPlus className="h-5 w-5" />
              Add Tax Rate
            </button>
          </div>
          {taxClass?.tax_rates.length > 0 && (
            <div>
              {taxClass?.tax_rates.map((item: any, index: number) => (
                <div key={index} className="p-4 border shadow-lg rounded-lg mb-4 flex justify-between items-start">
                  <div>
                    <div><strong>ID: </strong>{item?.id}</div>
                    <div><strong>Country: </strong>{item?.country}</div>
                    <div><strong>State:  </strong>{item?.state}</div>
                    <div><strong>Rate: </strong>{item?.rate}</div>
                    <div className="flex gap-2 items-center">
                      <strong>Status: </strong>
                      {item.is_active ? (
                          <NXCheck className="stroke-primary-600" />
                        ) : (
                          <NXCross className="stroke-red-600 h-3 w-3" />
                      )}
                    </div>
                  
                  </div>
                  <div className="flex gap-3">
                    <button
                      onClick={()=>setEdit(item)}
                      className="text-primary-400 hover:underline font-bold"
                    >
                      Edit
                    </button>
                    <button 
                      onClick={(e)=>{
                        e.preventDefault()
                        handleDelete(
                          item.id,
                          "Tax Rate",
                          api.deleteTaxRate,
                          getDetailTaxClass
                        )
                      }}
                    >
                      <NXDelete className="text-red-600"/>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
          </div>

          {isOpenTaxRateInput && (
            <TaxRateForm 
              isOpen={isOpenTaxRateInput} 
              onClose={()=>setIsOpenTaxRateInput(false)} 
              taxClassId={id} 
              refresh={getDetailTaxClass}/>
          )}

          {edit && (
            <TaxRateForm 
              edit={edit}
              isOpen={edit ? true : false} 
              onClose={()=>setEdit(null)} 
              taxClassId={id} 
              refresh={getDetailTaxClass}/>
          )}


        </div>
    </NxtbnDrawer>
  );
}

export default TaxClassView;
